import { reactive } from "vue";
import { defineStore } from "pinia";
import { SnackbarStatus } from "@/types";

export const useSnackbarStore = defineStore("snackbar", () => {
  const snackbar: SnackbarStatus = reactive({
    state: false,
    message: "",
    color: "error",
    timeout: 3000,
    itemBeingMoved: null,
  });

  return {
    snackbar,
  };
});
